module.exports = new __parcel__URL__("file-cabinet-open.8ad490de.svg").toString();